
import configuredVariant from "@/util/configuredVariant";
import {
  useMemo
} from "react";

export const useIsPreorder = (props) => {
  const {
    product, configurable_options 
  } = props || {}

  // 产品判断是否有 preorder
  const isHasPreOrder = useMemo(() => {
    if (product?.__typename === "ConfigurableProduct") {
      const {
        presale_product, variants 
      } = product || {};
      const {
        status: isPreOrder, note 
      } = presale_product || {};

      if (isPreOrder) {
        return true;
      }

      let hasPreOrderVariant = false; // 用于跟踪是否有预订的变体

      variants && variants.forEach(variant => {
        // debugger
        const {
          product: productVariant 
        } = variant || {};
        const {
          presale_product: presale_product_variant 
        } = productVariant || {};
        const {
          status: isPreOrderVariant, note: variantNote 
        } = presale_product_variant || {};

        if (isPreOrderVariant) {
          hasPreOrderVariant = true;
        }
      });

      return hasPreOrderVariant
    }

    if (product?.__typename === "SimpleProduct") {
      const {
        presale_product 
      } = product || {};
      const {
        status: isPreOrder 
      } = presale_product || {};

      return isPreOrder;
    }
  }, [product]);

  // 除了缺货的时候全是 preorder
  const isAllPreOrder = useMemo(() => {
    if (product?.__typename === "ConfigurableProduct") {
      const {
        presale_product, variants 
      } = product || {};
      const {
        status: isPreOrder, note 
      } = presale_product || {};

      if (isPreOrder) {
        return true;
      }

      let allPreOrderVariant = false;


      // 过滤掉所有的 outofstock  instock + preorder
      const withoutOutOfStockProductVariants = variants && variants.filter(variant => {
        return variant?.product?.stock_status !== "OUT_OF_STOCK";
      });

      // instock == 0, preordr == 0
      if (withoutOutOfStockProductVariants?.length === 0) {
        return false
      }

      // 过滤掉所有的 instock  preorder
      const preOrderVariants = withoutOutOfStockProductVariants && withoutOutOfStockProductVariants.filter(variant => {
        return variant?.product?.presale_product?.status;
      });


      // preorder ===  instock + preorder ;instock === 0 ; allPreOrderVariant= true
      if (preOrderVariants?.length === withoutOutOfStockProductVariants?.length) {
        allPreOrderVariant = true
      }


      return allPreOrderVariant
    }

    if (product?.__typename === "SimpleProduct") {
      const {
        presale_product 
      } = product || {};
      const {
        status: isPreOrder 
      } = presale_product || {};

      return isPreOrder;
    }
  }, [product]);


  if (!product) {
    return {
      isPreOrder: false,
      note: "",
    }
  }


  const configured_variant = configuredVariant(configurable_options, product)

  // cp 产品, 判断选中的这个颜色是否是 preorder
  if (configured_variant) {
    const {
      presale_product 
    } = configured_variant || {}

    const {
      status: isPreOrder, note, shipping_from, shipping_to
    } = presale_product || {}

    const newNote = `Ships within ${shipping_to + 1} days.`

    return {
      isPreOrder,
      note: newNote,
    }
  }

  // 简单产品
  const {
    presale_product 
  } = product || {}


  const {
    status: isPreOrder, note, shipping_from, shipping_to
  } = presale_product || {}

  const newNote = `Ships within ${shipping_to + 1} days.`


  return {
    isPreOrder,
    note: newNote,
    isHasPreOrder,
    isAllPreOrder
  }
}
